import { motion } from 'framer-motion';

interface IProps {
  children: React.ReactNode;
  onShowPanel?: () => void;
  onHidePanel?: () => void;
  gesture: 'hover' | 'tap';
}

export const MessageItemWrapper = ({ children, onShowPanel, onHidePanel, gesture }: IProps) => {
  const handleClick = (event: React.MouseEvent) => {
    if (gesture !== 'tap') return;

    const target = event.target as HTMLElement;
    const isReactionPill = target.closest('[data-reaction-pill="true"]');
    const shouldIgnoreTap = target.closest('[data-ignore-tap="true"], a, button');

    if (isReactionPill || shouldIgnoreTap) {
      return;
    }
    onShowPanel?.();
  };

  return (
    <motion.div
      onHoverStart={gesture === 'hover' ? onShowPanel : undefined}
      onHoverEnd={gesture === 'hover' ? onHidePanel : undefined}
      onClick={handleClick}
      whileTap={gesture === 'tap' ? { scale: 0.998 } : undefined}
      transition={{ type: 'spring', stiffness: 400, damping: 17 }}>
      {children}
    </motion.div>
  );
};
